import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { GovernmentAllocationEntryUpdateValidationSchema } from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/schemas/update.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateCompanyGovernmentAllocationEntry {
  governmentAllocationId?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useUpdateCompanyGovernmentAllocationEntry = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: UseUpdateCompanyGovernmentAllocationEntry) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateCompanyGovernmentAllocationEntry'],
    mutationFn: async (data: GovernmentAllocationEntryUpdateValidationSchema) => {
      const government_allocation_entry = {
        ...data,
        government_allocation_attributes: {
          ...data.government_allocation,
        },
        total_value: data.total_value ? unFormatCurrency(data.total_value) : undefined,
      }

      await privateAxios.put(`/billing/government_allocation_entries/${governmentAllocationId}`, {
        government_allocation_entry,
      })
    },
    onSuccess,
    onError,
  })
}
